<template>
  <div class="col-lg-12 col-md-10 col-sm-9 content container-fluid">
    <div class="wrapper">
      <div class="container-wrapper">
        <div id="alerts-container"></div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-lg-6">
        <h3 class="m-0"><a href="/#!/" class="tex-cdi-primary">Ofertas</a></h3>
        <p v-if="!loadingOffer">{{ offer.title }}</p>
        <span v-else class="fa fa-spin fa-spinner"></span>
      </div>
      <div class="col-xs-12 col-lg-6 text-right">
        <button
          class="btn btn-default download-table-btn"
          @click="deleteOffer()"
          :disabled="loadingOffer"
        >
          <span class="glyphicon glyphicon-trash"></span>
          ELIMINAR
        </button>
        <button
          class="btn btn-default download-table-btn"
          @click="archiveOffer()"
          :disabled="loadingOffer"
        >
          <span class="glyphicon glyphicon-file"></span>
          ARCHIVAR
        </button>
        <a
          href="/#!/edit-offer/{{offer.id}}"
          class="btn btn-default download-table-btn"
        >
          <span class="glyphicon glyphicon-pencil"></span> EDITAR
        </a>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 m-t-20">
        <div class="col-xs-12 b-t b-dashed b-transparent">
          <div class="col-xs-12 col-lg-4 m-t-20">
            <h4 class="tex-cdi-primary">TOTAL VENDIDO</h4>
            <h2 class="tex-cdi-primary m-0">
              RD$ {{ offer.total_sold ? offer.total_sold * offer.amount : 0 }}
            </h2>
          </div>
          <div class="col-xs-12 col-lg-4 b-l b-dashed b-transparent m-t-20">
            <h4 class="tex-cdi-primary">CUENTAS POR COBRAR</h4>
            <h2 class="tex-cdi-primary m-0">
              RD$
              {{
                offer.offersProvider
                  ? offer.offersProvider.accounts_to_charge
                  : 0
              }}
            </h2>
            <p class="tex-cdi-primary">({{ todayDate }})</p>
          </div>
          <div class="col-xs-12 col-lg-4 b-l b-dashed b-transparent m-t-20">
            <h4 class="tex-cdi-primary">CUENTAS POR PAGAR</h4>
            <h2 class="tex-cdi-primary m-0">
              RD$
              {{
                offer.offersProvider ? offer.offersProvider.accounts_to_pay : 0
              }}
            </h2>
            <p class="tex-cdi-primary">({{ todayDate }})</p>
          </div>
        </div>
      </div>
    </div>
    <div class="row m-t-20">
      <div class="col-xs-12 p-b-10 b-b b-grey">
        <ul class="nav nav-tabs offer-tabs">
          <li class="b-r b-grey active">
            <a data-toggle="tab" href="#offer-info" aria-expanded="true"
              >INFORMACIÓN DE LA OFERTA</a
            >
          </li>
          <li class="">
            <a data-toggle="tab" href="#clients" aria-expanded="false"
              >CLIENTES</a
            >
            <label class="bg-success clients-cant">
              {{ companies.length ? companies.length : 0 }}
            </label>
          </li>
        </ul>
      </div>
      <div class="col-xs-12 m-t-20 tab-content">
        <!--offer information-->
        <div class="tab-pane active" id="offer-info">
          <div class="col-xs-12 col-lg-6">
            <div class="panel details-panel panel-default">
              <div v-if="!loadingOffer" class="padding-20">
                <p>
                  ID:
                  <span class="text-bold pull-right"> #{{ offer.id }} </span>
                </p>
                <p>
                  Proveedor:
                  <span class="text-bold pull-right">
                    {{ offer.offersProvider.name }}
                  </span>
                </p>
                <p>
                  Representante:
                  <span class="text-bold pull-right">
                    {{ providerRepresentative.name }}
                  </span>
                </p>
                <p>
                  Teléfono del representante:
                  <span class="text-bold pull-right">
                    {{ providerRepresentative.phone }}
                  </span>
                </p>
                <p>
                  Correo del representante:
                  <span class="text-bold pull-right">
                    {{ providerRepresentative.email }}
                  </span>
                </p>
                <p>
                  Vigencia de la oferta:
                  <span class="text-bold pull-right">
                    {{ offer.validity == 1 ? "Temporal" : "Indefinida" }}
                  </span>
                </p>
                <p>
                  Fecha de creación:
                  <span class="text-bold pull-right">
                    {{ offer.created_at | dateFormat }}
                  </span>
                </p>
                <p>
                  Fecha de inicio:
                  <span class="text-bold pull-right" v-show="offer.start_date">
                    {{ offer.start_date | dateFormat }}
                  </span>
                </p>
                <p v-show="offer.validity == 1">
                  Fecha de expiración:
                  <span class="text-bold pull-right">
                    {{ offer.due_date | dateFormat }}
                  </span>
                </p>
                <p>
                  Tipo de oferta:
                  <span class="text-bold pull-right">
                    {{ offer.offersType.name }}
                  </span>
                </p>
                <p v-if="offer.type_id == 2">
                  Cuotas:
                  <span class="text-bold pull-right">
                    {{ offer.fee }}
                  </span>
                </p>
                <p v-if="offer.type_id == 1">
                  Días:
                  <span class="text-bold pull-right">
                    {{ offer.typeDays.days }}
                  </span>
                </p>
                <p>
                  Porcentaje de comisión:
                  <span class="text-bold pull-right">
                    {{ offer.comission_percent }}%
                  </span>
                </p>
                <p>
                  Ganancia por comisión:
                  <span class="text-bold pull-right">
                    {{ offer.comission_gain }}
                  </span>
                </p>
                <p>
                  Porcentaje de descuento:
                  <span class="text-bold pull-right">
                    {{ offer.discount_percent }}%
                  </span>
                </p>
                <p>
                  Total por Pagar:
                  <span class="text-bold pull-right">
                    {{ offer.total_due_amount }}
                  </span>
                </p>
                <p>
                  Segmento:
                  <span class="text-bold pull-right">
                    {{ offer.ServiceType.name }}
                  </span>
                </p>
              </div>
              <div v-else style="text-align: center">
                <span class="fa fa-spin fa-spinner"> </span>
              </div>
            </div>
          </div>

          <div class="col-xs-12 col-lg-6">
            <div class="panel details-panel panel-default">
              <div v-if="!loadingOffer" class="padding-20">
                <div class="fav-img pull-right">
                  <i
                    class="md md-star star-ico pull-right"
                    v-for="start in offerstarts"
                  ></i>
                </div>
                <div
                  class="img-holder col-xs-12 b-a b-grey b-rad-lg center"
                  :style="
                    'background: url(\'' +
                    getImageLink(offer) +
                    '\') no-repeat center; background-size: contain;'
                  "
                ></div>
                <div class="clearfix"></div>
                <div class="offer-title m-t-20">
                  <h4>Título</h4>
                  <p>{{ offer.title }}</p>
                </div>

                <div class="offer-desc">
                  <h4>Modelo</h4>
                  <p>{{ offer.model }}</p>
                </div>

                <div class="offer-desc">
                  <h4>Marca</h4>
                  <p>{{ offer.brands.name }}</p>
                </div>

                <div class="offer-desc">
                  <h4>Descripción</h4>
                  <p>{{ offer.description }}</p>
                </div>
              </div>
              <div v-else style="text-align: center">
                <span class="fa fa-spin fa-spinner"></span>
              </div>
            </div>
          </div>
        </div>
        <!--/.offer information-->
        <!-- clients table info-->
        <div class="tab-pane" id="clients">
          <div class="col-xs-12 m-t-20 m-b-20 text-right">
            <button
              v-show="companies.length"
              class="btn btn-primary m-l-5 m-r-5"
            >
              <i
                class="md md-file-download sm-ico b-r b-white p-r-20 m-r-20"
              ></i>
              DESCARGAR
            </button>
          </div>
          <div class="clearfix"></div>
          <template v-for="company in companies">
            <div class="col-xs-12 col-lg-3">
              <a
                v-link="{
                  name: 'purchased-offers',
                  params: { id: offerId, companyId: company.company_id },
                }"
              >
                <div class="account-item">
                  <div class="panel panel-default">
                    <div class="panel-heading">
                      <h3 class="panel-title">{{ company.company_name }}</h3>
                    </div>
                    <div class="panel-body">
                      <h3 class="text-center">{{ company.total }}</h3>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </template>
        </div>
        <!-- /.clients table info-->
      </div>
    </div>

    <!-- modal-content -->
    <div class="modal fade" id="_confirmLogoutModal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">Logout</h4>
          </div>
          <div class="modal-body">
            ¿Estás seguro que desea salir del sistema?
          </div>
          <div class="modal-footer">
            <div class="row">
              <div class="col-md-12 pull-right">
                <a data-dismiss="modal" class="btn btn-default">VOLVER</a>
                <a class="btn btn-primary" id="_submitLogout">LOGOUT</a>
              </div>
            </div>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->

    <!-- FOOTER   -->
    <footer class="footer b-t b-grey">
      <div class="copyright">
        2016 © Cash Depot - Todos los derechos reservados.
      </div>
    </footer>
    <!-- /.FOOTER   -->
  </div>
  <create-edit-offers :offer="offer" operation="edit"></create-edit-offers>
  <!-- Modal -->
  <div class="modal fade" id="eraseArchiveModal" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">
            &times;
          </button>
          <h4 class="modal-title">Confirmación</h4>
        </div>
        <div class="modal-body">
          <p>¿Borrar esta oferta?</p>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-default"
            data-dismiss="modal"
            @click="deleteOffer()"
          >
            Borrar
          </button>
          <button type="button" class="btn btn-default" data-dismiss="modal">
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- Modal -->
  <div class="modal fade" id="archiveModal" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">
            &times;
          </button>
          <h4 class="modal-title">Confirmación</h4>
        </div>
        <div class="modal-body">
          <p>¿Archivar esta oferta?</p>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-default"
            data-dismiss="modal"
            @click="archiveOffer()"
          >
            Archivar
          </button>
          <button type="button" class="btn btn-default" data-dismiss="modal">
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      offer: {},
      loadingOffer: true,
      providerRepresentative: {},
      todayDate: moment().format("DD/MM/YYYY"),
      specificOffer: {},
      companies: [],
      offerstarts: [],
      api: apiUrl,
      offerId: "",
      apiBase: apiUrl.replace("/v1", ""),
      mediaUrl: mediaUrl,
      serviceTypId: 1,
      imageNotFoundUrl:
        "http://3ie87c2dond928rt2e2zzo8o.wpengine.netdna-cdn.com/wp-content/themes/gonzo/images/no-image-featured-image.png",
    };
  },
  created() {
    //this.serviceTypId = this.$route.params.id > 0 ? this.$route.params.id : 1;
    this.offerId = this.$route.params.id;
    this.getOffer();
  },
  filters: {
    dateFormat: function (date) {
      return moment(date).format("DD/MM/YYYY");
    },
  },
  events: {
    "updated-offer"() {
      this.getOffer();
    },
  },
  methods: {
    archiveOffer() {
      let data = {};
      data.status_id = 2;
      $('[data-toggle="popover"]').popover("hide");
      swal(
        {
          title: "¿Estás seguro?",
          text: "¿Deseas archivar esta oferta?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "Cancelar",
          closeOnConfirm: false,
          closeOnCancel: false,
        },
        (isConfirm) => {
          if (isConfirm) {
            $.ajax({
              url: apiUrl + `/offers/${this.offerId}`,
              type: "PUT",
              data: data,
              contentType: "application/x-www-form-urlencoded",
              success: (response) => {
                swal(
                  {
                    title: "Felicidades!",
                    text: "¡La oferta se archivó correctamente!",
                    type: "success",
                    showCancelButton: false,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Continuar!",
                    closeOnConfirm: false,
                  },
                  function (isConfirm) {
                    if (isConfirm) {
                      window.location.href = "/";
                    }
                  }
                );
              },
              error: function (request, error) {
                swal(
                  "Ha ocurrido un error al intentar archivar la oferta",
                  "error"
                );
              },
            });
          } else {
            swal("Cancelado", "La oferta se mantendrá disponible", "error");
          }
        }
      );
    },
    displayOffer: function () {
      $("#new-offer").modal("show");
      $("#first-date").datepicker({
        minDate: -20,
        maxDate: "+1M +10D",
      });
      $("#last-date").datepicker();
    },
    getOffer() {
      this.loadingOffer = true;
      this.$http
        .get(
          apiUrl +
            `/offers?q=(id:${this.offerId},is_deleted:0)&relationships=offersProvider,brands,offersType,categories,typeDays,ServiceType,images`
        )
        .then(
          (response) => {
            this.offer = response.data[0];
            if (_.isEmpty(this.offer)) {
              swal(
                {
                  title: "Error",
                  text: "¡Esta ofeta no existe!",
                  type: "error",
                },
                function () {
                  window.location.href = "/";
                }
              );
            } else {
              this.getProviderRepresentative();
              this.getCompanies();
            }
            var i;
            for (i = 1; i <= this.offer.rate; i++) {
              this.offerstarts.push(i);
            }

            console.log(this.offerstarts);
          },
          (response) => {
            sweetAlert(
              "Oops...",
              "Ha ocurrido al cargar los estados !",
              "error"
            );
          }
        );
    },
    getImageLink(offer) {
      if (offer.images[0]) {
        return `${this.apiBase}${offer.images[0].path}`;
      }
      return this.imageNotFoundUrl;
    },
    getCompanies: function () {
      this.$http
        .get(apiUrl + "/offers/companies/" + this.offerId)
        .then((response) => {
          this.companies = response.data;
        });
    },
    getProviderRepresentative() {
      this.$http
        .get(
          apiUrl +
            `/providers?q=(id:${this.offer.provider_id})&relationships=ProviderRepresentative`
        )
        .then((response) => {
          this.providerRepresentative = response.data[0].ProviderRepresentative;
          this.loadingOffer = false;
        });
    },
    getAllOffers: function () {
      this.$http
        .get(
          apiUrl +
            "/offers?q=(is_deleted:0,service_type_id:" +
            this.serviceTypId +
            ")"
        )
        .then((response) => {
          this.offers = response.data.data;
          this.$nextTick(() => {
            this.startSlick(".buy-offer-slide");
          });
        });
    },
    orderOffer: function (offer) {
      console.log(offer);
      let data = new FormData();

      data.append("user_id", userId);
      data.append("offer_id", offer.id);

      this.$http({
        emulateJSON: true,
        emulateHTTP: true,
        url: apiUrl + "/users/" + userId + "/offers/" + offer.id,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: data,
      }).then(
        function (response) {
          swal("Felicidades !", "Oferta solicitada", "success");
          $("#view-offer").modal("toggle");
        },
        (response) => {
          sweetAlert(
            "Oops...",
            "Ha ocurrido un error solicitando la oferta " +
              response.status.message,
            "error"
          );
        }
      );
    },
    viewOfferInfo: function (id) {
      $("#viewOffer").modal("show");

      let fillOffer = this.offers.find((offer) => {
        return offer.id == id;
      });

      this.specificOffer = fillOffer;
    },
    deleteOffer() {
      let data = {};
      data.is_deleted = 1;
      data.status_id = 2;
      swal(
        {
          title: "¿Estás seguro?",
          text: "¿Deseas eliminar esta oferta?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si",
          cancelButtonText: "Cancelar",
          closeOnConfirm: false,
          closeOnCancel: false,
        },
        (isConfirm) => {
          if (isConfirm) {
            $.ajax({
              url: apiUrl + `/offers/${this.offerId}`,
              type: "PUT",
              data: data,
              contentType: "application/x-www-form-urlencoded",
              success: (response) => {
                swal(
                  {
                    title: "Felicidades!",
                    text: "¡La oferta se eliminó correctamente!",
                    type: "success",
                    showCancelButton: false,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Continuar!",
                    closeOnConfirm: false,
                  },
                  function (isConfirm) {
                    if (isConfirm) {
                      window.location.href = "/";
                    }
                  }
                );
              },
              error: function (request, error) {
                swal(
                  "Ha ocurrido un error al intentar borrar la oferta",
                  "error"
                );
              },
            });
          } else {
            swal("Cancelado", "La oferta se mantendrá disponible", "error");
          }
        }
      );
    },
    startSlick(slickContainer) {
      $(slickContainer).slick({
        lazyLoad: "ondemand",
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        infinite: false,
        speed: 300,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              dots: true,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// offers-information-new.vue?4a449f12